import React from 'react';
import Seo from '../components/common/Seo';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import SolutionsSection from '../components/home/SolutionsSection';
import IndustriesSection from '../components/home/IndustriesSection';
import StatsSection from '../components/home/StatsSection';
import WhyChooseUsSection from '../components/home/WhyChooseUsSection';
import PartnersSection from '../components/home/PartnersSection';
import ClientsSection from '../components/home/ClientsSection';
import ContactSection from '../components/home/ContactSection';
import { seo } from '@/data/seo';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo {...seo.home} />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <SolutionsSection />
      <IndustriesSection />
      <StatsSection />
      <WhyChooseUsSection />
      <PartnersSection />
      <ClientsSection />
      <ContactSection />
    </div>
  );
};

export default Home;
